import memoryAxiosInstance from '../../../core/api/memoryAxios';

export const reviewService = {
  getFlashcardToReview: async (
    userUuid: string,
    deckUuids: string[]
  ): Promise<IFlashcardReview[]> => {
    const { data } = await memoryAxiosInstance.post(
      `/api/v1/review-flashcards/${userUuid}`,
      {
        deckUuids,
      }
    );
    return data;
  },
  saveAnswerFlashcard: async (
    userUuid: string,
    flashcardDeckUuid: string,
    rating: 'easy' | 'medium' | 'hard'
  ): Promise<void> => {
    await memoryAxiosInstance.post(
      `/api/v1/review-flashcards/${userUuid}/save-answer`,
      {
        flashcardDeckUuid,
        rating,
      }
    );
  },
  saveAnswerByFlashcardUuid: async (
    userUuid: string,
    flashcardUuid: string,
    rating: 'easy' | 'medium' | 'hard',
    subject?: {
      id: string;
      name: string;
    }
  ) => {
    await memoryAxiosInstance.post(
      `/api/v1/flashcards/${userUuid}/add-to-discipline-with-rating`,
      {
        flashcardUuid,
        rating,
        subject
      }
    );
  },
};
